import { CreateThreadBtn } from './CreateThreadBtn'
import { MyThreads } from './MyThreads'
import { ThreadDetails } from './ThreadDetails'
import type { MessagesPageStateController } from '../useMessagesPageState'

export const MessagesPageFullView = ({
  controller,
}: {
  controller: MessagesPageStateController
}) => {
  const {
    threadsFilterOptions,
    handleThreadCreated,
    threadListRefreshKey,
    selectedThread,
    threadStatusMap,
    setThreadStatusMap,
    setSelectedThread,
    handleThreadRead,
    handleThreadUpdated,
    setThreadsFilterOptions,
  } = controller

  return (
    <div
      className="behuman-v2-scope flex flex-col gap-4 bg-[#F6F7F9] p-4 text-[#1F2733]"
      // The shell reserves room for the recent-patients bar on top of its own
      // 64px header, so the page has to subtract both or it overflows the
      // viewport whenever that bar has pills — which would break the
      // independently scrolling list and the anchored composer.
      style={{ height: 'calc(100vh - 64px - var(--recent-bar-height, 0px))' }}
    >
      <div className="flex shrink-0 items-start justify-between gap-4">
        <div>
          <p className="text-xs font-bold tracking-[1.2px] text-[#E5533D] uppercase">
            Communication Center
          </p>
          <h1 className="m-0 text-[28px] font-extrabold tracking-[-0.6px]">Messages</h1>
          <p className="mt-0.5 text-sm text-[#6B7280]">
            Secure conversations with providers and care-team members.
          </p>
        </div>

        <CreateThreadBtn onCreated={handleThreadCreated} label="Create thread" primary />
      </div>

      <div className="grid min-h-0 flex-1 grid-cols-1 gap-4 lg:grid-cols-[360px_minmax(0,1fr)]">
        <div className="min-h-0 overflow-hidden">
          <MyThreads
            refreshKey={threadListRefreshKey}
            selectedThreadId={selectedThread?.thread.id}
            threadStatusMap={threadStatusMap}
            onThreadStatusMapChange={setThreadStatusMap}
            onSelectThread={setSelectedThread}
            threadsFilterOptions={threadsFilterOptions}
            onThreadsFilterOptionsChange={setThreadsFilterOptions}
          />
        </div>
        <div className="min-h-0 overflow-hidden">
          <ThreadDetails
            threadSummary={selectedThread}
            onThreadRead={handleThreadRead}
            onThreadUpdated={handleThreadUpdated}
          />
        </div>
      </div>
    </div>
  )
}
